import { render } from "./BaseWrapper.vue?vue&type=template&id=3bc2c6ae&scoped=true&ts=true&lang=pug"
import script from "./BaseWrapper.vue?vue&type=script&lang=ts"
export * from "./BaseWrapper.vue?vue&type=script&lang=ts"

import "./BaseWrapper.vue?vue&type=style&index=0&id=3bc2c6ae&lang=scss&scoped=true"

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc2c6ae"]])

export default __exports__